import { Fragment } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  Paper,
  Button,
} from "@mui/material";
import CardHolder from "./CardHolder";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RenderOnRole from "../../components/RenderOnRole";
import CardView from "./CardView";

export default function MainView({
  idCustomer,
  handleCreditClick,
  handleDebitClick,
  handleVelocityClick,
  showAdminButtons,
}) {
  return (
    <Fragment>
      <Box sx={{ padding: 3, backgroundColor: "#f5f5f5" }}>
        {/* Two Column Layout */}
        <Grid container spacing={3}>
          {/* Card Holder Section */}
          <Grid item xs={12} lg={6}>
            <Paper elevation={3} sx={{ height: "fit-content" }}>
              <Box
                sx={{
                  backgroundColor: "#0d7f81",
                  color: "white",
                  padding: 2,
                  borderTopLeftRadius: "4px",
                  borderTopRightRadius: "4px",
                }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar sx={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                    <PersonIcon />
                  </Avatar>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{ fontSize: 14 }}
                  >
                    Card Holder Information
                  </Typography>
                </Box>
              </Box>
              <CardContent sx={{ padding: 3 }}>
                <CardHolder idCustomer={idCustomer} />
              </CardContent>
            </Paper>
          </Grid>

          {/* Card Information Section */}
          <Grid item xs={12} lg={6}>
            <Paper elevation={3} sx={{ height: "fit-content" }}>
              <Box
                sx={{
                  backgroundColor: "#0d7f81",
                  color: "white",
                  padding: 2,
                  borderTopLeftRadius: "4px",
                  borderTopRightRadius: "4px",
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" gap={2}>
                    <Avatar sx={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                      <CreditCardIcon />
                    </Avatar>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{ fontSize: 14 }}
                    >
                      Card Information
                    </Typography>
                  </Box>
                  {showAdminButtons && (
                    <RenderOnRole roles={["pc-program-super-admin"]}>
                      <Box>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={handleCreditClick}
                          sx={{
                            mr: 1,
                            backgroundColor: "rgba(255,255,255,0.2)",
                            "&:hover": {
                              backgroundColor: "rgba(255,255,255,0.3)",
                            },
                          }}
                        >
                          Credit
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          startIcon={<RemoveIcon />}
                          onClick={handleDebitClick}
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            "&:hover": {
                              backgroundColor: "rgba(255,255,255,0.3)",
                            },
                          }}
                        >
                          Debit
                        </Button>
                      </Box>
                    </RenderOnRole>
                  )}
                </Box>
              </Box>
              <CardContent sx={{ padding: 3 }}>
                <CardView
                  idCustomer={idCustomer}
                  handleCreditClick={handleCreditClick}
                  handleDebitClick={handleDebitClick}
                  handleVelocityClick={handleVelocityClick}
                  showAdminButtons={showAdminButtons}
                />
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
}
